import { clearSession } from "./SessionStorage.web";

let expiring = false;

export function isSessionExpiring(): boolean {
  return expiring;
}

// Several in-flight requests can fail at once when a session dies, so the
// redirect must happen only once.
export async function expireSession(): Promise<void> {
  if (expiring) {
    return;
  }

  expiring = true;
  await clearSession();
  window.location.replace("/");
}
